import {
    Box,
    Typography,
    FormLabel
} from "@mui/material";

export default function SimpleTable({ title, rows, columns, maxHeight }) {
    return (
        <Box sx={{ py: 1, px: 1, width: "100%" }}>
            <FormLabel sx={{ fontSize: 14, fontWeight: 600, mb: 1 }}>
                {title}
            </FormLabel>

            <Box
                sx={{
                    width: "100%",
                    maxHeight: maxHeight,
                    border: "1px solid #D1D5DB",
                    borderRadius: "12px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    backgroundColor: "#fff"
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${columns.length}, 1fr)`,
                        backgroundColor: "#FFF2F0",
                        borderBottom: "1px solid #D1D5DB",
                        fontWeight: 600,
                        fontSize: 12,
                        p: 1,
                        color: "#374151"
                    }}
                >
                    {columns.map((col) => (
                        <Typography key={col.field} sx={{ fontWeight: 600 }}>
                            {col.headerName}
                        </Typography>
                    ))}
                </Box>

                {/* Body */}
                <Box
                    sx={{
                        flex: 1,
                        overflowY: "auto"
                    }}
                >
                    {rows?.map((row, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "grid",
                                gridTemplateColumns: `repeat(${columns.length}, 1fr)`,
                                borderBottom: "1px solid #D1D5DB",
                                fontSize: 12,
                                p: 1,
                                alignItems: "center",
                                color: "#717883"
                            }}
                        >
                            {columns.map((col) => (
                                <Typography key={col.field}>
                                    {col.renderCell
                                        ? col.renderCell({ value: row[col.field], row })
                                        : row[col.field]}
                                </Typography>
                            ))}
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}